// extracted by mini-css-extract-plugin
export var black = "_3v-6";
export var brand = "_3v-1";
export var ddefault = "_3v-0";
export var error = "_3v-3";
export var gray = "_3v-2";
export var highContrast = "_3v-8";
export var outline = "_3v-7";
export var success = "_3v-5";
export var warning = "_3v-4";